<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>用户列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <!--工具条 begin-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="姓名：">
              <el-input v-model="searchForm.userName" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="登录名：">
              <el-input v-model="searchForm.loginName" placeholder="登录名"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button size="mini" type="primary" @click="findResult(null)">查 询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button size="mini" type="primary" @click="openAddUserDialog">新 增</el-button>
          </el-form-item>
      </el-form>
    </el-col> 
    <!--工具条 end-->

    <!-- 列表显示 begin-->
    <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
      <el-table :data="userList" style="width: 100%" stripe resizable="true" v-loading="tableLoading" class="tablebar">
          <el-table-column type="expand">
              <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                  <el-form-item label="邮箱：">
                  <span>{{ props.row.mail }}</span>
                  </el-form-item>
                  <el-form-item label="电话：">
                  <span>{{ props.row.phone }}</span>
                  </el-form-item>
              </el-form>
              </template>
          </el-table-column>
        <!-- 第一行显示数据 -->
        <el-table-column prop="realname" label="姓名" width="200" sortable align="center"></el-table-column>
        <el-table-column prop="username" label="用户名" sortable align="center"></el-table-column>
        <!-- <el-table-column prop="institution" label="所属机构" sortable align="center"></el-table-column> -->
        <el-table-column prop="role" label="角色" sortable align="center"></el-table-column>    
        <!-- 操作按钮 -->
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="showEditDialog(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <div slot="empty" class="empty">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </el-table>
      <!-- 列表显示 end-->


      <!--新增对话框界面 begin-->
      <AddUserDialog ref="addUserDialog" v-on:signStatusVerdict="listenSignStatus"> </AddUserDialog>
      <!-- 新增对话框界面 end -->

      <!--编辑对话框界面 begin-->
      <EditUserDialog ref="editUserDialog" v-bind:user="user" v-on:signStatusVerdict="listenSignStatus"> </EditUserDialog>
      <!-- 编辑对话框界面 end -->
    </el-col>

    <el-col :span="24" class="foolbar">
      <el-pagination 
        background 
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :page-size="pageSize"
        :page-sizes = pageSizes
        :total="total" 
        hide-on-single-page 
        style="float:right;">
      </el-pagination>
    </el-col>
    <!-- 在此添加新的页面元素 -->
  </el-row>
</template>

<script>
import API_USER from "../../../api/api_user";
import AddUserDialog from "./AddUser.vue";
import EditUserDialog from "./EditUser.vue";



export default {
  data() {
    return {
      tableLoading:false,
      searchForm:{
        userName:"",
        loginName:"",
        insId:"",
      },
      //机构列表
      // insList:[],
      user:{},
      userList:[],
      //在此添加新的数据定义
      //页码
      page: 1,
      //每页数量
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      //总数
      total: 0,
      clientHeight: window.innerHeight - 258,
    };
  },

  components:{
    AddUserDialog,
    EditUserDialog,
  },

  methods: {
    //从后台获取用户列表
    findUsers() {
      this.tableLoading = true
      let that = this;
      //发送获取用户列表信息http请求
      let params = {
          page: that.page,
          pageSize: that.pageSize,
          userName: that.searchForm.userName,
          loginName: that.searchForm.loginName,
          // insId:that.searchForm.insId
      };
      API_USER.getUsers(params)
        .then(res => {
          if (res && res.users) {
            //赋值到users:[]
            that.userList = Object.values(res.users); //解决返回一个时为object问题
            that.total = res.total;
          }
          else{
            that.userList = [];
          }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        }).finally(()=>{
          this.tableLoading = false
        });;
    },

    //通过userUID从后台获取用户详细信息
    findUserInfo(_userId) {
      let that = this;
      let params = {
        userId: _userId
      };
      console.log("......findUserInfo params:" + JSON.stringify(params));
      //发送http请求
      API_USER.getUser(params)
        .then(res => {
          if (res) {
            //赋值
            that.user = res;
            this.$refs.editUserDialog && this.$refs.editUserDialog.openDialog(that.user);
          }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    //显示新建对话框
    openAddUserDialog() {
        this.$refs.addUserDialog && this.$refs.addUserDialog.openDialog();
    },

    //显示编辑对话框
    showEditDialog: function(index, row) {
        let that = this;
        that.findUserInfo(row.userId);
    },

    //删除操作
    handleDelete: function(index, row) {
      let that = this;
      that
        .$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let params = {
            userId: row.userId
          };

          console.log(".........userDel params:" + JSON.stringify(params));
          //调用post请求，进行删除
          API_USER.delUser(params)
            .then(res => {
              console.log(res);
              if (0 === res.errorCode) {
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });

                //更新列表
                that.findUsers();
              } else {
                that.$message({
                  showClose: true,
                  message: res.errorInfo,
                  type: "error"
                });
              }
            })
            .catch(e => {
              that.$message({
                showClose: true,
                type: "error",
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "取消删除"
          });
        });
    },
    listenSignStatus: function(signStatus){
        this.findUsers();
    },

    findResult(){
        //点击查询按钮，分页初始化为1
        let _page = 1;
        //重新搜索时进行重置
        this.total = 0;
        //查询前清除查询列表信息
        this.userList = null;
        //进行分页查询
        this.getRows(_page);
    },

    getRows: function(_page) {
        this.page = _page;
        this.findUsers();
    },

    handleSizeChange(val) {
        this.pageSize = val;
        this.findUsers();
    },

    //分页选择处理
    handleCurrentChange: function(val) {
        this.getRows(val);
    },

    //初始化表格高度
    initHeight: function() {
        this.clientHeight = (document.documentElement.clientHeight - 258) + 'px';
    },
  },
  mounted() {
    window.addEventListener('resize', this.initHeight);
    this.initHeight();
    this.findUsers();
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/SysMng/User/UserManage.vue